<template>
  <el-dialog
    class="select-dialog"
    :title="$t('common.select') +' '+ this.$l('route.camera','智联摄像')"
    :visible.sync="dialogVisible"
    width="80%"
    top="5vh"
    append-to-body>
    <vm-table
      ref="vmTable"
      v-loading="loading"
      :filter.sync="search"
      url="cameras">
      <template slot="adSearch">
        <vm-search :label="$l('maintWorkOrder.filter','关键字检索')">
          <el-input v-model.trim="search.filter" :placeholder="$t('common.search')" clearable></el-input>
        </vm-search>
        <vm-search :label="$l('elevator.onlineStatus', '在线状态')">
          <el-select
            v-model="search.onlineStatus"
            :placeholder="$t('common.pleaseSelect')"
            style="width: 100%"
            clearable>
            <el-option :label="$l('workOrder.online', '在线')" :value="1"></el-option>
            <el-option :label="$l('workOrder.offline', '离线')" :value="0"></el-option>
          </el-select>
        </vm-search>
      </template>
      <el-table-column prop="deviceCode" align="center" :label="$l('camera.deviceCode', '设备编号')"></el-table-column>
      <el-table-column prop="hwVersion" align="center" :label="$l('deviceGateway.hardVer', '硬件版本')"></el-table-column>
      <el-table-column prop="swVersion" align="center" :label="$l('deviceGateway.softVer', '软件版本')"></el-table-column>
      <el-table-column prop="signalValue" align="center" :label="$l('camera.signalValue', '信号值')"></el-table-column>
      <el-table-column prop="onlineStatus" align="center" :label="$l('elevator.onlineStatus', '在线状态')">
        <template v-slot="scope">
          <el-tag class="normal" v-if="scope.row.onlineStatus === 1">
            {{$l("workOrder.online", "在线")}}
          </el-tag>
          <el-tag class="abnormal" v-if="scope.row.onlineStatus === 0">
            {{$l("workOrder.offLine", "离线")}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="lastPingTime" align="center" :label="$l('camera.lastKeepaliveTime', '最后保活时间')"></el-table-column>
      <el-table-column prop="upgradeTime" align="center" :label="$l('camera.lastUpdateTime', '最后升级时间')"></el-table-column>
      <el-table-column :label="$t('common.operation')" align="center" fixed="right">
        <template v-slot="scope">
          <el-button type="text" style="color: #00C291;" @click="handleSelect(scope.row)">{{$t("common.select")}}</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>
<script>

  export default {
    data() {
      return {
        dialogVisible: false,
        loading: true,
        search: {bindStatus: 0},
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.loading=false;
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleSelect(row) {
        this.$emit("cameraSelect", row);
        this.dialogVisible = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
